module.exports = __webpack_public_path__ + "static/img/57-3.64fbc2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/57-3.jpg
// module id = c4y8
// module chunks = 0